import { Component, OnInit, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-simple-counter",
  templateUrl: "./simple-counter.component.html",
  styleUrls: ["./simple-counter.component.scss"],
})
export class SimpleCounterComponent implements OnInit {
  @Input() itemsArray: Array<any> | number;
  @Input() control: FormControl;
  @Input() itemId: any;
  @Input() isDisabled: boolean = false;

  public index = 0;

  constructor() {}

  ngOnInit() {
    if (this.itemId && Array.isArray(this.itemsArray)) {
      this.index = this.itemId - 1;
    } else if (this.itemId && typeof this.itemsArray === "number") {
      this.index = this.itemId;
    }
  }

  increase() {
    if (!this.isComponentDisabled) {
      if (typeof this.itemsArray === "number") {
        this.index++;
        this.save();
      } else if (this.index < this.itemsArray.length - 1) {
        this.index++;
        this.save();
      }
    }
  }

  decrease() {
    if (!this.isComponentDisabled) {
      if (this.index > 0) {
        this.index--;
        this.save();
      }
    }
  }

  save() {
    if (!this.isComponentDisabled) {
      let result;
      if (typeof this.itemsArray === "number") {
        result = this.index;
      } else {
        result = this.itemsArray[this.index].id;
      }
      this.control.setValue(result);
    }
  }

  get isComponentDisabled() {
    return this.isDisabled;
  }

  get currentValue() {
    if (typeof this.itemsArray === "number") {
      return this.index;
    } else {
      return this.itemsArray.length > 0
        ? this.itemsArray[this.index].display_name
        : "";
    }
  }
}
